import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Hey ${u.name.split(" ")[0]}!`);
      nav(u.role === "admin" ? "/admin" : redirect);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="login-page">
      <span className="tag-sticker bg-cyan text-xl rotate-tilt-l inline-block mb-2">welcome back</span>
      <h1 className="font-display text-5xl uppercase">Log in</h1>
      <form onSubmit={submit} className="mt-8 brut p-6 flex flex-col gap-4">
        <label className="font-bold uppercase tracking-wider text-sm">Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="brut-input w-full mt-1 normal-case" data-testid="login-email" />
        </label>
        <label className="font-bold uppercase tracking-wider text-sm">Password
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="brut-input w-full mt-1 normal-case" data-testid="login-password" />
        </label>
        <button type="submit" disabled={loading} className="brut-btn bg-orange text-white py-3 mt-2" data-testid="login-submit">
          {loading ? "Logging in…" : "Log in"}
        </button>
      </form>
      <p className="mt-6 text-center">No account? <Link className="font-bold underline decoration-[3px] decoration-[#FF5A00]" to="/signup">Sign up</Link></p>
    </div>
  );
}
